import v3PlatformUtils from './v3platform';
function genUUID(){
  function S4() {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  }
  return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
}

/**
* 清除记录状态
* @params {Object} records 实体记录
*/
function clearRecordState(records){
  if(records && records.length > 0){
      for(var i = 0,len = records.length;i<len;i++){
        var record = records[i];
        if(true === record._metadata_.isCurrent){
          record._metadata_ = {
            isCurrent : false,
            isSelected : false,
            dsName : record._metadata_.dsName
          }
        }
      }
  }
  return record;
}
export default {
  /**
   * 设置当前行
   * @param {Object} params
   * {
   *    record : {},//设置成当前行的数据
   *    entityRecords : []//实体全部数据
   * }
   */
  setCurrentRecord : function(params){
    if(!params | !params.record){
      return;
    }
    var instance = params.vueObj;
    if(instance){
      var record  =params.record;
      instance.markCurrent(record);
      // if(v3PlatformUtils.isRunInV3Service()){
      //   var dsName = record._metadata_.dsName;
      //   v3PlatformUtils.synCurrentRecordToDs(instance,dsName,record);
      // }
    }else if(params.entityRecords && params.entityRecords.length > 0){
      var cId = params.record.id;
      if(!cId)
        throw new Error("无法读取记录的id属性，不能设置为当前行");
      /* 如果已经是当前行，就不设置了 */
      if(params.record._metadata_ && params.record._metadata_.isCurrent)
        return;
      var dsName = null;
      var errorRecord = [];
      var entityRecords = params.entityRecords;
      for(var i = 0,len = entityRecords.length;i<len;i++){
        var record = entityRecords[i];
        if(undefined == record._metadata_){
          throw new Error("实体记录存在非源数据的记录，请检查.");
        }
        if(cId == record.id){
          record._metadata_ = {
            isCurrent : true,
            isSelected : true,
            dsName : record._metadata_.dsName
          }
          entityRecords.current = record;
        }else if(true === record._metadata_.isCurrent){
          record._metadata_ = {
            isCurrent : false,
            isSelected : false,
            dsName : record._metadata_.dsName
          }
        }
      } 
    }
  },
  /**
   * 获取所有选中记录
   * @return Array
   */
  getSelectedRecord : function(params){
    var result = [];
    if(typeof(params) == "object"){
      var vueObj = params.vueObj;
      var records = params.records;
      if(vueObj){
        return vueObj.getSelectedRecords();
      }
      if(vueObj && records && records.length > 0){
        var dsName = params.records[0]._metadata_.dsName;
        var rs = v3PlatformUtils.getSelectedRecords(vueObj, dsName);
        if(rs && rs.length > 0){
          var ids = [];
          for(var i = 0,len = rs.length;i<len;i++){
            ids.push(rs[i].id);
          }
          for(var i = 0,len = records.length;i<len;i++){
            var record = records[i];
            if(ids.indexOf(record.id) !=-1){
              result.push(record);
            }
          }
        }
      }else if(params.length > 0){
        for(var i=0,l=params.length;i<l;i++){
          var record = params[i];
          var metadata = record._metadata_;
          if(metadata&&metadata.isSelected){
            result.push(record);
          }
        }
      }
    }
    return result;
  },
  /**
   * 获取当前行
   * @return Object
   */
  getCurrentRecord : function(params){
    if(typeof(params) == "object"){
      var vueObj = params.vueObj;
      var records=  params.records;
      if(vueObj){
        return vueObj.getCurrentRecord();
      }
      if(vueObj && records && records.length > 0){
        var record = params.records[0];
        var dsName = record._metadata_.dsName;
        var rd = v3PlatformUtils.getCurrentRecord(vueObj, dsName);
        if(rd){
          for(var i = 0,len = records.length;i<len;i++){
            var record = records[i];
            if(record.id == rd.id){
              return record;
            }
          }
        }
      }else if(params.length > 0){
        for(var i=0,l=params.length;i<l;i++){
          var rd = params[i];
          var metadata = rd._metadata_;
          if(metadata && true === metadata.isCurrent){
            params.current = rd;
            return rd;
          }
        }
      }
    }
    return null;
  },
  /**
   * 设置选中记录
   * @param {Object} records 需要选中的记录
   * 
   */
  setSelectRecords : function(params){
    if(typeof(params) == "object" && params.records && params.records.length > 0){
      var vueObj = params.vueObj;
      var isSelect =  params.isSelect === true ? true : false;
      var records = params.records;
      if(vueObj){
        //使用实例提供的方法
        vueObj.markSelected(records);
        //var dsName = records[0]._metadata_.dsName;
        //v3PlatformUtils.synSelectRecordToDs(vueObj, dsName, params.records, isSelect);
      }else{
        for(var i = 0,len = records.length;i<len;i++){
          var record = records[i];
          var _metadata_ = record._metadata_;
          if(_metadata_ && true != _metadata_.isSelected){
            record._metadata_.isSelected = isSelect;
          }
        }
      }
    }
  },

  /**
   * 是否已选中
   */
  isSelected : function(params){
    var vueObj = params.vueObj;
    if(vueObj && params.record){
      return vueObj.isSelected(params.record);
      //var dsName = params.record._metadata_.dsName;
      //return v3PlatformUtils.isSelected(vueObj, dsName, params.record);
    }else{
      var metadata = params._metadata_;
      return metadata&&metadata.isSelected;
    }
  },

  /**
   *是否当前行
  */
  isCurrent : function(params){
    var vueObj = params.vueObj;
    if(vueObj && params.record){
      return vueObj.isCurrent(params.record)
      //var dsName = params.record._metadata_.dsName;
      //return v3PlatformUtils.isCurrent(vueObj, dsName, params.record);
    }else{
      var metadata = params._metadata_;
      return metadata&&metadata.isCurrent;
    }
  },

  /**
  * 插入记录
  * @param {Object} params 实体记录
  * {
  *   'records':[],// 新增的实体数据
  *   'entityRecords':[]// 原来实体的数据
  * }
  */
  insertRecords : function(params){
    if(params && params.records){
      var records = params.records;
      var currentRecord = {};
      for(var i = 0,len = records.length;i<len;i++){
        var record = records[i];
        if(!record.id){
          record.id = genUUID();
        }
        var isCurrent = (i == (len - 1)) ? true : false;
        record._metadata_ = {
          isCurrent : isCurrent,
          isSelected : isCurrent
        };
        if(isCurrent)
          currentRecord = record;
      }
      var entityRecords = params.entityRecords;
      /* 清除记录状态 */
      if(entityRecords && entityRecords.length > 0){
        clearRecordState(entityRecords);
      }
      entityRecords.push.apply(entityRecords, records);
      entityRecords.current = currentRecord;
    }
  },

  /**
  * 删除记录
  * @param {Obejct} params 实体记录
  * {
  *   'records':[],// 新增的实体数据
  *   'entityRecords':[]// 原来实体的数据
  * }
  */
  deleteRecords : function(params){
    if(params && params.records && params.records.length > 0 && params.entityRecords && params.entityRecords.length > 0){
      var currentId = null;
      var rIds = [];
      var records = params.records;
      for(var i = 0,len = records.length;i<len;i++){
        var id = records[i].id;
        /* 删除的记录中是否包含选中记录 */
        if(records[i]._metadata_.isCurrent === true){
          currentId = id;
        }
        rIds.push(id);
      }
      var entityRecords = params.entityRecords;
      for(var i = 0;i<entityRecords.length;i++){
        var rId = entityRecords[i].id;
        if(rIds.indexOf(rId) != -1){
          entityRecords.splice(i,1);
          i--;
        }
      }
      if(currentId != null ){
        if(entityRecords.length > 0){
          /* 清除记录状态 */
          clearRecordState(entityRecords);
          entityRecords[0]._metadata_ = {
            isCurrent : true,
            isSelected : true,
            dsName : entityRecords[0]._metadata_.dsName
          }
          entityRecords.current = entityRecords[0];
        }else{
          entityRecords.current = [];
        }
      }
      
    }
  },
  /**
  * 更新记录
  * @param {Obejct} params 实体记录
  * {
  *   'records':[],// 更新的实体数据
  *   'entityRecords':[]// 原来实体的数据
  * }
  */
  updateRecords : function(params){
    if(params && params.records && params.records.length >0){
      var records = params.records;
      var rId_datas = {};
      for(var i = 0,len = records.length;i<len;i++){
        var data = records[i];
        rId_datas[data.id] = data;
      }
      var entityRecords = params.entityRecords;
      for(var i = 0,len = entityRecords.length;i<len;i++){
        var data = entityRecords[i];
        if(rId_datas[data.id]){
          var newRecord = rId_datas[data.id];
          for(var key in newRecord){
            if(key != "_metadata_" && newRecord.hasOwnProperty(key)){
              data[key] = newRecord[key];
            }
          }
        }
      }
    }
  },
  /**
  * 重置实体记录字段数据为null
  * @param {Array} records 记录列表
  */
  clearRecordDatas : function(records){
    if(undefined != records && records.length > 0){
      for(var i = 0,len = records.length;i < len; i++){
        var record = records[i];
        if(record){
          for(var key in record){
            if(record.hasOwnProperty(key) && key != "id" && key != "_metadata_"){
              record[key] = null;
            }
          }
        }
      }
    }
  },
	markMultipleDs : function(params){
    var dsName;
    var vueObj = params.vueObj;
    var records = params.records;
    if(vueObj){
      vueObj.markDatasourceMultipleSelect();
      // if(records._metadata_){
      //   dsName = records._metadata_.dsName;
      // }else if(records.length > 0 && records[0]._metadata_){
      //   dsName = records[0]._metadata_.dsName;
      // }
      // if(dsName){
      //   v3PlatformUtils.markMultipleDs(vueObj, dsName);
      // }
    }
	}

}



// WEBPACK FOOTER //
// ./src/Datasource.js